(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-csc-profile-polish"] && !Shopify.designMode) return;
  try {
    
(function () {
  const lifecycleKey = '__csCscGalleryLightboxV1';
  if (window[lifecycleKey]) {
    window[lifecycleKey].init(document);
    return;
  }
  const initialized = new WeakSet();
  let active = null;

  function init(root) {
    const profiles = root.matches?.('article.cs-csc-profile') ? [root] : Array.from(root.querySelectorAll?.('article.cs-csc-profile') || []);
    for (const profile of profiles) {
      if (initialized.has(profile)) continue;
      const dialog = profile.querySelector('dialog[data-csc-lightbox]');
      const image = dialog?.querySelector('[data-csc-lightbox-image]');
      const count = dialog?.querySelector('[data-csc-lightbox-count]');
      const stage = dialog?.querySelector('[data-csc-lightbox-stage]');
      const closeButton = dialog?.querySelector('[data-csc-lightbox-close]');
      const previousButton = dialog?.querySelector('[data-csc-lightbox-prev]');
      const nextButton = dialog?.querySelector('[data-csc-lightbox-next]');
      if (!dialog || typeof dialog.showModal !== 'function' || !image || !count || !stage || !closeButton || !previousButton || !nextButton) continue;
      initialized.add(profile);
      let items = [], index = 0, trigger = null, scrollState = null, swipe = null, suppressClickUntil = 0;
      image.draggable = false;

      function update(next) {
        if (!items.length) return;
        index = (next + items.length) % items.length;
        const item = items[index];
        image.src = item.href;
        image.alt = item.querySelector('img')?.alt || '';
        count.textContent = `${index + 1} / ${items.length}`;
        for (const button of [previousButton, nextButton]) {
          button.disabled = items.length < 2;
          button.hidden = items.length < 2;
        }
      }

      function cleanup() {
        if (!scrollState) return;
        const { body, overflow, priority } = scrollState;
        scrollState = null;
        if (overflow) body.style.setProperty('overflow', overflow, priority);
        else body.style.removeProperty('overflow');
        if (active?.profile === profile) active = null;
        swipe = null;
        const previousTrigger = trigger;
        trigger = null;
        if (previousTrigger?.isConnected) previousTrigger.focus({ preventScroll: true });
      }

      function close() {
        if (dialog.open) dialog.close();
        cleanup();
      }

      profile.addEventListener('click', event => {
        const item = event.target.closest?.('a[data-csc-gallery-item]');
        if (!item || !profile.contains(item) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || dialog.open) return;
        const available = Array.from(profile.querySelectorAll('a[data-csc-gallery-item]')).filter(link => link.getAttribute('href'));
        const selected = available.indexOf(item);
        if (selected < 0) return;
        if (active && active.profile !== profile) active.close();
        items = available;
        trigger = item;
        update(selected);
        try { dialog.showModal(); }
        catch { trigger = null; return; }
        event.preventDefault();
        const body = document.body;
        scrollState = { body, overflow: body.style.getPropertyValue('overflow'), priority: body.style.getPropertyPriority('overflow') };
        body.style.setProperty('overflow', 'hidden');
        active = { profile, close };
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', close);
      previousButton.addEventListener('click', () => { if (dialog.open) update(index - 1); });
      nextButton.addEventListener('click', () => { if (dialog.open) update(index + 1); });
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => { if (!dialog.open) cleanup(); });
      dialog.addEventListener('keydown', event => {
        if (!dialog.open || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          update(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      dialog.addEventListener('click', event => {
        if (Date.now() < suppressClickUntil) { event.preventDefault(); return; }
        if (event.target === dialog || event.target === stage) close();
      });

      function startSwipe(x, y, id) {
        swipe = dialog.open && items.length > 1 ? { x, y, id } : null;
      }
      function endSwipe(x, y, id, event) {
        const start = swipe;
        swipe = null;
        if (!start || start.id !== id || !dialog.open) return;
        const dx = x - start.x, dy = y - start.y;
        if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
        update(index + (dx < 0 ? 1 : -1));
        suppressClickUntil = Date.now() + 400;
        if (event.cancelable) event.preventDefault();
      }
      if ('PointerEvent' in window) {
        stage.addEventListener('pointerdown', event => {
          if (event.isPrimary === false || !['touch', 'pen'].includes(event.pointerType)) return;
          startSwipe(event.clientX, event.clientY, event.pointerId);
        });
        stage.addEventListener('pointerup', event => endSwipe(event.clientX, event.clientY, event.pointerId, event));
        stage.addEventListener('pointercancel', () => { swipe = null; });
      } else {
        stage.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) { swipe = null; return; }
          const touch = event.touches[0];
          startSwipe(touch.clientX, touch.clientY, touch.identifier);
        }, { passive: true });
        stage.addEventListener('touchend', event => {
          const touch = Array.from(event.changedTouches).find(item => item.identifier === swipe?.id);
          if (touch) endSwipe(touch.clientX, touch.clientY, touch.identifier, event);
          else swipe = null;
        }, { passive: false });
        stage.addEventListener('touchcancel', () => { swipe = null; });
      }
    }
  }

  window[lifecycleKey] = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains?.(active.profile)) active.close();
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-world-podcast"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', function (event) {
    const current = event.target;
    if (!(current instanceof HTMLAudioElement) || !current.closest('.cs-world-podcast')) return;
    document.querySelectorAll('.cs-world-podcast audio').forEach(function (audio) {
      if (audio !== current && !audio.paused) audio.pause();
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
